import { createSlice } from '@reduxjs/toolkit';
import { AsyncState } from '../types';
import { LanguageApi, LanguageDto } from '../../http';
import { FindAllResponse } from '../../http/types';
import { createFetchAsync } from '../slice.utils';

const languageApi = new LanguageApi();

export const fetchLanguagetAsync = createFetchAsync(
  'language',
  'findAll',
  async (params, { rejectWithValue }) => {
    try {
      return await languageApi.findAll(params);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const forceFetchLanguage = fetchLanguagetAsync.asyncThunk;

export const fetchLanguage = (payload) => (dispatch, getState) => {
  const {
    language: { findAll }
  } = getState();

  if (!findAll.payload && findAll.loading == false) {
    dispatch(forceFetchLanguage(payload));
  }
};

type LanguageState = {
  findAll: AsyncState<FindAllResponse<LanguageDto>>;
};

const initialState: LanguageState = {
  findAll: fetchLanguagetAsync.initialState
};

const language = createSlice({
  name: 'language',
  initialState,
  reducers: {},
  extraReducers: {
    ...fetchLanguagetAsync.extraReducers
  }
});

export default language.reducer;
